/**
 * History Actions (Undo/Redo)
 *
 * Delegates to the Rool SDK's checkpoint-based undo/redo system.
 * The SDK operates on checkpoints — each undo restores the space to the
 * last checkpoint, regardless of how many mutations happened since.
 */

import type { RoolChannel } from '@rool-dev/sdk';
import * as toast from '../../lib/toast';
import { clearLocallyModifiedNodes } from '../../lib/canvas-object-store';

/**
 * Undo the last checkpointed operation.
 */
export async function undo(space: RoolChannel | null): Promise<void> {
	if (!space) return;
	if (await space.canUndo()) {
		// Clear the grace period so rebuildGraph reads the reverted SDK data
		// instead of preserving stale store values from the pre-undo state.
		clearLocallyModifiedNodes();
		await space.undo();
		toast.undo('Undo');
	}
}

/**
 * Redo the last undone operation.
 */
export async function redo(space: RoolChannel | null): Promise<void> {
	if (!space) return;
	if (await space.canRedo()) {
		clearLocallyModifiedNodes();
		await space.redo();
		toast.redo('Redo');
	}
}
